// Origenes del filtro de pedidos (Pedidos y Planificacion). Las claves son las del scope
// `Order.with_source`: Mercado Libre y Shopify son canal de venta, asi que un pedido de ML
// que entro por Bsale sale en los dos.
export const ORDER_SOURCES = [
    { key: 'bsale',       label: 'Bsale' },
    { key: 'relbase',     label: 'Relbase' },
    { key: 'meli',        label: 'Mercado Libre' },
    { key: 'shopify',     label: 'Shopify' },
    { key: 'manual',      label: 'Manual' },
    { key: 'importacion', label: 'Importación Excel' },
];
